var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Method } from '@attraqt/http-client-common';
import { v4 as uuidv4 } from 'uuid';
import validate from './models/validateSchema';
var Activity = /** @class */ (function () {
    function Activity() {
        this.isInitialized = false;
        this.sample = { action: '', target: {} };
        this.user = { identities: {}, segments: [], traits: {} };
    }
    Activity.prototype.initUser = function (storage) {
        if (!this.user.identities.sessionid) {
            this.user.identities.sessionid =
                storage.getItem('attraqtsessionid') || uuidv4();
        }
        this.storage.setItem('attraqtsessionid', this.user.identities.sessionid);
    };
    Activity.prototype.assertIsInit = function () {
        if (!this.isInitialized) {
            throw Error('The activities module must be initialized before using methods.');
        }
    };
    Activity.prototype.init = function (options, httpClient) {
        var _a;
        if (!options || !options.trackerKey)
            throw Error('A tracker key is required to initialize the activities module.');
        var region = ((_a = options.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || Region.EU;
        this.apiUrl = "http".concat(region !== Region.DEV ? 's' : '', "://collect-").concat(region, ".attraqt.io/").concat(options.trackerKey);
        this.storage = options.storage;
        this.httpClient = httpClient;
        this.initUser(this.storage);
        this.hasOptedOut = this.storage.getItem('attraqtoptout') === 'true';
        this.isInitialized = true;
    };
    Activity.prototype.send = function (activities, options) {
        var _this = this;
        if (!this.isInitialized) {
            throw Error('The activities module must be initialized before sending activities.');
        }
        var activitiesWithUserData = [].concat(activities).map(function (act) {
            var activity = __assign(__assign({}, act), { user: act && act.user ? act.user : _this.user });
            if (!validate(activity)) {
                throw new Error('The provided activity does not match the required format.');
            }
            return activity;
        });
        if (this.hasOptedOut)
            return null;
        var request = __assign({ method: Method.Post, headers: { 'Content-Type': 'application/json' }, url: this.apiUrl, body: JSON.stringify(activitiesWithUserData) }, options);
        return this.httpClient.send(request);
    };
    Activity.prototype.sendAndStoreClusters = function (activities, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result, profile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.send(activities, options)];
                    case 1:
                        response = _a.sent();
                        if ((response === null || response === void 0 ? void 0 : response.status) < 300) {
                            result = JSON.parse(response.body);
                            try {
                                profile = result.profiles[Object.keys(result.profiles)[0]];
                                this.storage.setItem('attraqtuserclusters', JSON.stringify(profile.clusters));
                            }
                            catch (_b) { }
                            return [2 /*return*/, result];
                        }
                        else {
                            return [2 /*return*/, response];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Activity.prototype.setUser = function (user) {
        this.assertIsInit();
        if (!user || !validate(__assign(__assign({}, this.sample), { user: user }))) {
            throw new TypeError('The provided user does not match the required format.');
        }
        this.setUserIdentities(user.identities);
        this.setUserSegments(user.segments);
        this.setUserTraits(user.traits);
        this.initUser(this.storage);
    };
    Activity.prototype.addUserIdentity = function (identityRepository, identity) {
        this.assertIsInit();
        if (typeof identityRepository !== 'string' ||
            typeof identity !== 'string') {
            throw new TypeError('identityRepository and identity must be strings.');
        }
        this.user.identities[identityRepository.toLocaleLowerCase()] = identity;
        this.initUser(this.storage);
    };
    Activity.prototype.setUserIdentities = function (identities) {
        this.assertIsInit();
        if (!validate(__assign(__assign({}, this.sample), { user: { identities: identities } })) ||
            Object.keys(identities).length === 0) {
            throw new TypeError('The provided identities do not match the required format.');
        }
        this.user.identities = identities;
        this.initUser(this.storage);
    };
    Activity.prototype.addUserSegment = function (segment) {
        this.assertIsInit();
        if (typeof segment !== 'string') {
            throw new TypeError('segment must be a string.');
        }
        this.user.segments.push(segment);
    };
    Activity.prototype.setUserSegments = function (segments) {
        this.assertIsInit();
        if (!Array.isArray(segments) || segments.some(function (x) { return typeof x !== 'string'; })) {
            throw new TypeError('segments must be an array of strings.');
        }
        this.user.segments = segments;
    };
    Activity.prototype.addUserTrait = function (trait, traitValue) {
        this.assertIsInit();
        if (typeof trait !== 'string' || typeof traitValue !== 'string') {
            throw new TypeError('trait and traitValue must be strings.');
        }
        this.user.traits[trait] = traitValue;
    };
    Activity.prototype.setUserTraits = function (traits) {
        this.assertIsInit();
        if (!validate(__assign(__assign({}, this.sample), { user: { identities: {}, traits: traits } }))) {
            throw new TypeError('The provided traits do not match the required format.');
        }
        this.user.traits = traits;
    };
    Activity.prototype.clearUser = function () {
        this.assertIsInit();
        this.user = { identities: {}, segments: [], traits: {} };
        this.storage.removeItem('attraqtsessionid');
        this.initUser(this.storage);
    };
    Activity.prototype.optOut = function () {
        this.assertIsInit();
        this.hasOptedOut = true;
        this.storage.setItem('attraqtoptout', 'true');
    };
    Activity.prototype.optIn = function () {
        this.assertIsInit();
        this.hasOptedOut = false;
        this.storage.removeItem('attraqtoptout');
    };
    return Activity;
}());
export { Activity };
export var Region;
(function (Region) {
    Region["DEV"] = "dev";
    Region["EU"] = "eu";
    Region["AP1"] = "ap1";
    Region["AP2"] = "ap2";
})(Region || (Region = {}));
//# sourceMappingURL=activity.js.map